import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

const EventContext = createContext(null);

export const EventProvider = ({ children }) => {
  // Initialize selected event from localStorage or null
  const [selectedEvent, setSelectedEventState] = useState(() => {
    const stored = localStorage.getItem('selectedEvent');
    return stored ? stored : null;
  });

  // Update localStorage whenever selected event changes
  const setSelectedEvent = useCallback((eventId) => {
    setSelectedEventState(eventId);
    if (eventId) {
      localStorage.setItem('selectedEvent', eventId);
    } else {
      localStorage.removeItem('selectedEvent');
    }
  }, []);

  // Clear selected event (useful for logout or switching contexts)
  const clearSelectedEvent = useCallback(() => {
    setSelectedEventState(null);
    localStorage.removeItem('selectedEvent');
  }, []);

  const value = useMemo(() => ({
    selectedEvent,
    setSelectedEvent,
    clearSelectedEvent,
  }), [selectedEvent, setSelectedEvent, clearSelectedEvent]);

  return <EventContext.Provider value={value}>{children}</EventContext.Provider>;
};

export const useEvent = () => {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error('useEvent must be used within an EventProvider');
  }
  return context;
};
